"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CortexRegistryType = void 0;
var CortexRegistryType;
(function (CortexRegistryType) {
    CortexRegistryType[CortexRegistryType["VertexAI"] = 1] = "VertexAI";
    CortexRegistryType[CortexRegistryType["SageMaker"] = 2] = "SageMaker";
    CortexRegistryType[CortexRegistryType["Tamarind"] = 3] = "Tamarind";
})(CortexRegistryType || (exports.CortexRegistryType = CortexRegistryType = {}));
